import React, { useState } from "react";
import style from "../SignIn/SignIn.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

import { Form, Formik } from "formik";
import FormikField from "../../stuffs/FormikField/FormikField";
import * as Yup from "yup";
import axios from "axios";

import { NavLink } from "react-router-dom";

import {
  Modal,
  Button as ButtonModal,
  Spinner,
} from "react-bootstrap";

import { Button } from "@mui/material";

interface FormValues {
  email: string;
}

const initialValues: FormValues = {
  email: "",
};

const ForgotPassword: React.FC = () => {
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wymagany poprawny adres email!")
      .required("Pole wymagane"),
  });

  const handleSubmit = async (
    values: FormValues
  ) => {
    try {
      setLoading(true);
      setMsg("");
      setShow(true);

      const response = await axios.post(
        "/api/users/forgot-password",
        values
      );

      setMsg(response.data.msg);
    } catch (error) {
      setMsg(
        "Wystąpił błąd podczas wysyłania linku."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShow(false);
    setMsg("");
  };

  return (
    <PageLayout>
      <div className={style.SignIn}>
        <div className={style.LoginBox}>
          <h1>Reset hasła</h1>

          <p>
            Podaj adres e-mail przypisany do
            Twojego konta. Wyślemy Ci link do
            ustawienia nowego hasła.
          </p>

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={ForgotPasswordSchema}
          >
            {({
              isValid,
              dirty,
              errors,
              touched,
            }) => (
              <Form className={style.Form}>
                <div className={style.Field}>
                  <FormikField
                    name="email"
                    label="Email"
                    variant="standard"
                    required
                    err={
                      errors.email &&
                      touched.email
                    }
                  />
                </div>

                <div className={style.Button}>
                  <Button
                    variant="outlined"
                    disabled={!dirty || !isValid}
                    type="submit"
                  >
                    Wyślij link
                  </Button>
                </div>
              </Form>
            )}
          </Formik>

          <div className={style.Links}>
            <div>
              <NavLink
                to="/signin"
                className={style.MenuItem}
              >
                Wróć do logowania
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {loading ? (
              <Spinner animation="border" />
            ) : (
              msg
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <ButtonModal
            variant="primary"
            onClick={handleCloseModal}
          >
            Zamknij
          </ButtonModal>
        </Modal.Footer>
      </Modal>
    </PageLayout>
  );
};

export default ForgotPassword;